import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { softwareFormSubmitClassicPublicRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareFormSubmitClassicPublicRoute.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { formSubmitPageEntrypoint } from '@atlassian/jira-router-routes-business-entries/src/ui/spa/business/form-submit-public/index.tsx';

export const softwareFormSubmitClassicPublicRouteEntry = createEntry(
	softwareFormSubmitClassicPublicRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'classic-form-submit-public',
		layout: chromelessLayout,
		resources: [...jiraSpaResources()],

		// This public route should not include
		// DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
		// remove all usages of projectKey.
		entryPoint: () =>
			expVal('jira_forms_public_access_experiment', 'isEnabled', 'false')
				? formSubmitPageEntrypoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-classic-projects-entries/src/softwareFormSubmitClassicPublicRouteEntry.tsx',
				whichExportToUse: 'softwareFormSubmitClassicPublicRouteEntry',
			},

			enabled: true,
		},
	}),
);
